var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAgi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "17px",
    viewBox: "0 0 63 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#006A36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1828,0.40642 L0.0008,15.78642 L5.8388,15.78642 L6.9828,13.31442 L11.3928,13.31442 L11.4648,15.78642 L17.7688,15.78642 L16.0868,0.40642 L8.1828,0.40642 Z M11.2608,3.77242 L11.3048,3.77242 L11.2888,9.56642 L8.6928,9.56642 L11.2608,3.77242 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8026,10.14102 L27.8906,10.14102 L27.4966,11.99502 C26.9586,12.22902 26.3866,12.31302 25.8106,12.31302 C25.0226,12.31302 24.4846,12.03702 24.2586,11.39702 C24.0846,10.90902 24.1746,9.88502 24.4906,8.39502 C24.7646,7.09502 25.1706,5.58302 25.6006,4.96502 C26.0286,4.34702 26.7246,3.87902 27.6406,3.87902 C28.0246,3.87902 28.3686,3.96302 28.5826,4.15502 C28.7986,4.34702 28.9226,4.66702 28.8406,5.15702 L34.5486,5.15702 C35.2466,1.55702 33.1046,0.00102 28.3766,0.00102 C22.6686,0.00102 19.2446,3.38902 18.2486,8.09702 C17.2506,12.80302 19.2386,16.19502 24.7766,16.19502 C27.2886,16.19502 30.1446,15.78502 32.6626,15.16902 L34.3666,7.11702 L26.4426,7.11702 L25.8026,10.14102 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "33.8728 15.78642 39.9648 15.78642 43.2228 0.40642 37.1308 0.40642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8914,8.72502 C52.9274,8.70502 56.0494,8.99502 60.7274,10.05502 L61.0794,8.47502 C59.5834,8.23502 56.5814,8.07102 50.8914,8.72502",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9862,12.90562 L43.6282,14.50162 C50.1762,13.99162 54.9362,14.85162 57.9902,15.78962 L59.4402,15.78962 L59.4822,15.60762 C52.4362,13.36162 46.4102,12.96762 43.9862,12.90562",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3914,9.28742 C54.6494,11.78742 57.9734,13.75342 59.6334,14.92742 L60.4414,11.32542 C59.0054,10.90142 52.8594,9.17342 48.3914,9.28742",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7948,9.29622 L44.3528,11.26822 C49.2268,11.39222 52.9448,12.29222 55.5988,13.27822 C50.0448,10.58822 46.6628,9.62622 44.7948,9.29622",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7966,0.36662 L45.0806,8.02062 C46.0466,8.37462 46.9546,8.72062 47.8126,9.05862 C48.0486,8.98462 48.2946,8.91062 48.5486,8.83662 C51.8466,7.40662 56.5046,5.48662 61.6986,5.71662 L62.8986,0.36662 L46.7966,0.36662 Z",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5604,8.30802 C53.6544,7.57802 57.4984,7.05402 61.2944,7.52202 L61.4644,6.58002 C60.9064,6.55602 58.3804,5.95002 50.5604,8.30802",
    id: "Fill-16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAgi);
export default __webpack_public_path__ + "static/media/logo-agi.93bafae1fd32b1248cb81c7b39876ef9.svg";
export { ForwardRef as ReactComponent };